<template>
  <a-drawer
    :visible="visible"
    class="assetHeadManage"
    placement="right"
    title="资产字段个人配置"
    width="85%"
    @close="handleCancel"
    destroyOnClose
  >
    <a-layout class="equipment-parameters-content assetHeadManageLayout">
      <a-layout-sider id="leftLayoutHeadDrawer" :width="layoutWidth" class="leftLayout">
        <div class="treeDiv">
          <assetType-list
            ref="assetTypeList"
          ></assetType-list>
        </div>
        <div v-if="showLeftBtn" class="retraction" @click="closeLeft">
          <div class="retractionBtn"></div>
        </div>
      </a-layout-sider>
      <a-layout-content class="rightLayout">
        <div v-if="showRightBtn" class="retractionRight" @click="openLeft">
          <div class="retractionBtn"></div>
        </div>
        <div class="content">
          <table-data ref="tableDom" @setChangeHeadList="setChangeHeadList"></table-data>
        </div>
      </a-layout-content>
    </a-layout>
  </a-drawer>
</template>

<script>
import assetTypeList from './modules/assetTypeList.vue'
import tableData from './modules/tableData.vue'

export default {
  components: {
    assetTypeList,
    tableData
  },
  data () {
    return {
      layoutWidth: '240',
      showLeftBtn: true,
      showRightBtn: false,
      visible: false,
      changeHeadList: []
    }
  },
  watch: {
    layoutWidth (newValue, oldValue) {
      if (Number(newValue) > 0) {
        this.showRightBtn = false
        this.showLeftBtn = true
      } else {
        this.showRightBtn = true
        this.showLeftBtn = false
      }
    }
  },
  mounted () {
  },
  methods: {
    // 重新获取树
    initTree () {
      this.$refs.departmentTreeList.getTreeData()
    },
    // 收起左侧树
    closeLeft () {
      this.layoutWidth = '0'
      const dom = document.getElementById('leftLayoutHeadDrawer')
      dom.style.padding = '0px'
    },
    openLeft () {
      this.layoutWidth = '240'
      const dom = document.getElementById('leftLayoutHeadDrawer')
      dom.style.padding = '16px'
    },
    // 设置改变过的类型
    setChangeHeadList (list) {
      this.changeHeadList = list
    },
    open () {
      this.visible = true
    },
    handleCancel () {
      this.visible = false
      // 判断是否需要重新获取表头
      this.$emit('retrievesTheTableHeader', this.changeHeadList)
    }
  }
}
</script>
<style lang="less" scoped>
.assetHeadManage {
  /deep/.ant-drawer-body {
    height: calc(100% - 55px);
    .assetHeadManageLayout {
      height: 100%;
    }
  }
}
.dict-content {
  //height: 100%;
  overflow-y: hidden;
}
#leftLayoutHeadDrawer {
  background: #fff;
  padding-right:16px;
  margin-right:1px
}
.rightLayout {
  position: relative;
  //padding: 10px 12px;
  background: #fff;
  .content {
    height: 100%;
    margin-left: 14px;
  }
}
.treeDiv {
  height: 100%;
  overflow-y: hidden;
}
.ant-divider-horizontal {
  margin: 10px 0;
}
.retraction {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 14px;
  height: 100px;
  background: #f0f2f5;
  background: linear-gradient(135deg, transparent 10px, #f0f2f5 0) top left,
  linear-gradient(45deg, transparent 10px, #f0f2f5 0) bottom left;
  background-size: 100% 50%;
  background-repeat: no-repeat;
  cursor: pointer;
  .retractionBtn {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 10px;
    height: 14px;
    background: #08409F;
    background: linear-gradient(135deg, transparent 7px, #08409F 0) top left,
    linear-gradient(45deg, transparent 7px, #08409F 0) bottom left;
    background-size: 100% 50%;
    background-repeat: no-repeat;
  }
}
.retractionRight {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 14px;
  height: 100px;
  background: #f0f2f5;
  background: linear-gradient(225deg, transparent 10px, #f0f2f5 0) top left,
  linear-gradient(310deg, transparent 10px, #f0f2f5 0) bottom left;
  background-size: 100% 50%;
  background-repeat: no-repeat;
  cursor: pointer;
  .retractionBtn {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 10px;
    height: 14px;
    background: #08409F;
    background: linear-gradient(225deg, transparent 7px, #08409F 0) top left,
    linear-gradient(315deg, transparent 7px, #08409F 0) bottom left;
    background-size: 100% 50%;
    background-repeat: no-repeat;
  }
}
</style>
